export default __webpack_public_path__ + "static/media/fs-ii-search.070886e9.svg";